import { render } from "./StudentsTable.vue?vue&type=template&id=65f53102"
import script from "./StudentsTable.vue?vue&type=script&lang=js"
export * from "./StudentsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__